/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import { CircularProgress } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { CardMatching, JobLayout } from '@orientaction/components';
import { useStyles } from './style';
import { ReactComponent as ArrowLeft } from '../../../Asset/svg/arrow_left_alt-2.svg';
import { useHistory, useParams } from 'react-router-dom';
import MatchingSensDuTravail from './MatchingSensDuTravail';
import MatchingBesoinMotivation from './MatchingBesoinMotivation';
import MatchingPersonality from './MatchingPersonality';
import MatchingTalent from './MatchingTalent';
import MatchingEquilibre from './MatchingEquilibre';
import { useEffect, useState } from 'react';
import { apiServiceNative } from '../../../utils/fetchNative';
import { useMajorTest } from '@orientaction/hooks';
import { round } from 'lodash';

type LinkType = {
  sens: string;
  preference: string;
  besoin: string;
  harmony: string;
  ebook: string;
};

const DetailCandidat = (props: any) => {
  const classes = useStyles();
  const history = useHistory();
  const { id }: any = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [candidature, setCandidature] = useState<any>({});
  const { getUserAllTestLatestResult } = useMajorTest();
  const [linkTest, setLinkTest] = useState<LinkType>({
    sens: '',
    preference: '',
    besoin: '',
    harmony: '',
    ebook: '',
  });
  const [dataFromEbook, setDataFromEbook] = useState({});
  const getEbookRecrutement = async (idUser: number) => {
    try {
      const response = await apiServiceNative.get(`/api/job/ebook-recrutement-user/${idUser}`);
      return response.data;
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchCandidatureData = async () => {
      setLoading(true);
      try {
        const resp = await apiServiceNative.get(`/api/candidatures/${id}?populate=*`);
        let link: LinkType = {
          sens: '',
          preference: '',
          besoin: '',
          harmony: '',
          ebook: '',
        };

        if (resp && resp.data) {
          setCandidature(resp.data);
          const responseEbookRecrutement = await getEbookRecrutement(
            resp.data?.attributes?.user.data.id
          );
          if (responseEbookRecrutement) {
            link = {
              ...link,
              ebook: `/ebook-recrutement/${responseEbookRecrutement?.id}/${true}/1`,
            };
            setDataFromEbook(responseEbookRecrutement?.attributes);
          }
          const allTests = await getUserAllTestLatestResult(resp.data?.attributes?.user.data.id);
          if (allTests.meaningTestLastResult) {
            link = {
              ...link,
              sens: `/resultat-meaning-value/${allTests.meaningTestLastResult.id}`,
            };
          }
          if (allTests.preferenceTestLastResult) {
            link = {
              ...link,
              preference: `/resultat-preference/${allTests.preferenceTestLastResult.id}`,
            };
          }
          if (allTests.needsProTestLastResult) {
            link = {
              ...link,
              besoin: `/resultat-need-pro/${allTests.needsProTestLastResult.id}`,
            };
          }

          if (allTests.harmonyTestLastResult) {
            link = {
              ...link,
              harmony: `/resultat-harmony/${allTests.harmonyTestLastResult.id}`,
            };
          }
          setLinkTest(link);
          setLoading(false);
        }
      } catch (e) {
        console.error(e);
        setLoading(false);
      }
    };
    fetchCandidatureData();
  }, [id]);

  const checkingMatchingData = (candidatureT: CandidatureType) => {
    return (
      candidatureT?.sensMatching &&
      candidatureT?.besoinsMatching &&
      candidatureT?.personalityMatching &&
      candidatureT?.equilibreMatching &&
      candidatureT?.talentsMatching
    );
  };

  return (
    <JobLayout isNew3={true}>
      {loading && <CircularProgress className={classes.loader} />}
      {!loading && candidature && (
        <>
          <div className={classes.header}>
            <div className={classes.btn} onClick={() => history.push('/admin/emploi/candidats')}>
              <ArrowLeft />
              <div style={{ marginLeft: 15 }}>Retour</div>
            </div>

            <Grid container={true} justifyContent="space-between" alignItems="center">
              <Grid item={true} lg={4}>
                <div className={classes.containerProfile}>
                  {candidature?.attributes?.user.data.attributes.photoUri ? (
                    <img
                      className={classes.imgProfile}
                      src={candidature?.attributes?.user.data.attributes.photoUri}
                      alt=""
                    />
                  ) : (
                    <div className={classes.initial}>
                      <span>{`${candidature?.attributes?.user.data.attributes?.firstname
                        ?.charAt(0)
                        .toUpperCase()}${candidature?.attributes?.user.data.attributes?.lastname
                        ?.charAt(0)
                        .toUpperCase()}`}</span>
                    </div>
                  )}
                  <Typography variant="h6" className={classes.nameProfile}>
                    {`${candidature?.attributes?.user.data.attributes.firstname} ${candidature?.attributes?.user.data.attributes.lastname}`}
                    <div style={{ marginTop: 10 }}>
                      {candidature?.attributes?.user.data.attributes.email}
                    </div>
                    <div>{candidature?.attributes?.user.data.attributes.phone}</div>
                  </Typography>
                </div>
              </Grid>
              <Grid
                container={true}
                item={true}
                lg={7}
                style={{ border: '1px dashed #5E65A3', borderRadius: 5 }}>
                <Grid
                  item={true}
                  lg={5}
                  style={{ borderBottom: '1px dashed #5E65A3', borderRight: '1px dashed #5E65A3' }}>
                  <div className={classes.cellule}>
                    <Typography variant="h6" className={classes.cellulename}>
                      Distance domicile/emploi (géo)
                      <div style={{ marginTop: 2 }}>
                        {typeof candidature?.attributes?.distance === 'undefined' ||
                        candidature?.attributes?.distance === null
                          ? 'NC'
                          : `${round(candidature?.attributes?.distance / 1000, 1)} km`}
                      </div>
                    </Typography>
                  </div>
                </Grid>
                <Grid
                  item={true}
                  lg={3}
                  style={{ borderBottom: '1px dashed #5E65A3', borderRight: '1px dashed #5E65A3' }}>
                  <div className={classes.cellule}>
                    <Typography variant="h6" className={classes.cellulename}>
                      Niveau de diplôme
                      <div style={{ marginTop: 2 }}>
                        {candidature?.attributes?.user.data.attributes.diploma || 'NC'}
                      </div>
                    </Typography>
                  </div>
                </Grid>
                <Grid item={true} lg={4} style={{ borderBottom: '1px dashed #5E65A3' }}>
                  <div className={classes.cellule}>
                    <Typography variant="h6" className={classes.cellulename}>
                      Nombre d’années d’expériences
                      <div style={{ marginTop: 2 }}>
                        {candidature?.attributes?.user.data.attributes.yearExperiences || 'NC'}
                      </div>
                    </Typography>
                  </div>
                </Grid>
                <Grid item={true} lg={5} style={{ borderRight: '1px dashed #5E65A3' }}>
                  <div className={classes.cellule}>
                    <Typography variant="h6" className={classes.cellulename}>
                      Situation actuelle
                      <div style={{ marginTop: 2 }}>
                        {candidature?.attributes?.user.data.attributes.poste || 'NC'}
                      </div>
                    </Typography>
                  </div>
                </Grid>
                <Grid item={true} lg={3} style={{ borderRight: '1px dashed #5E65A3' }}>
                  <div className={classes.cellule}>
                    <Typography variant="h6" className={classes.cellulename}>
                      Mois de préavis
                      <div style={{ marginTop: 2 }}>
                        {candidature?.attributes?.user.data.attributes.noticeDeparture || 'NC'}
                      </div>
                    </Typography>
                  </div>
                </Grid>
                <Grid item={true} lg={4}>
                  <div className={classes.cellule}>
                    <Typography variant="h6" className={classes.cellulename}>
                      Ville
                      <div style={{ marginTop: 2 }}>
                        {candidature?.attributes?.user.data.attributes.town || 'NC'}
                      </div>
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <div className={classes.body}>
            <div style={{ position: 'relative', top: '-60px' }}>
              <div className={classes.containerSection}>
                <CardMatching
                  value={Math.round(candidature?.attributes?.matchingGlobal || 0)}
                  title={candidature?.attributes?.job.data.attributes.title || 'NC'}
                  isComplete={checkingMatchingData(candidature?.attributes)}
                />
              </div>
              <div className={classes.containerSection}>
                <MatchingSensDuTravail
                  data={candidature?.attributes?.matchingData?.sens}
                  linkEbook={linkTest.ebook}
                  linkResultTest={linkTest.sens}
                />
              </div>
              <div className={classes.containerSection}>
                <MatchingBesoinMotivation
                  data={candidature?.attributes?.matchingData?.besoins}
                  linkEbook={linkTest.ebook}
                  linkResultTest={linkTest.besoin}
                  dataFromEbook={dataFromEbook}
                />
              </div>
              <div className={classes.containerSection}>
                <MatchingPersonality
                  data={candidature?.attributes?.matchingData?.personality}
                  linkEbook={linkTest.ebook}
                  linkResultTest={linkTest.preference}
                />
              </div>
              <div className={classes.containerSection}>
                <MatchingTalent
                  data={candidature?.attributes?.matchingData?.talents}
                  linkEbook={linkTest.ebook}
                  linkResultTest={linkTest.harmony}
                  dataFromEbook={dataFromEbook}
                  dataFromJob={candidature?.attributes?.job?.data?.attributes?.matching_talents}
                />
              </div>
              <div className={classes.containerSection}>
                <MatchingEquilibre
                  data={candidature?.attributes?.matchingData?.equilibre}
                  linkEbook={linkTest.ebook}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </JobLayout>
  );
};

export default DetailCandidat;
